export function adminDailyOpenSummaryEndpoint(
  workerBaseUrl: string | undefined,
  firebaseFunctionsBaseUrl: string | undefined,
  projectId: string | undefined,
  production = false,
): string {
  const workerBase = (workerBaseUrl || '').trim().replace(/\/+$/, '')
  if (workerBase) return `${workerBase}/admin/daily-open-summary`
  if (production) throw new Error('Notification Worker URL is not configured for this production build.')
  const functionsBase = (firebaseFunctionsBaseUrl || `https://asia-south1-${projectId || ''}.cloudfunctions.net`).trim().replace(/\/+$/, '')
  return `${functionsBase}/sendDailyOpenSummary`
}